export default "__VITE_ASSET__B96kDlg4__"